import { SORT_DIRECTION } from 'constants/app.constant';
export var getSortedCourseByAverageScore = function (a, b, direction) {
    if (direction === SORT_DIRECTION.ASC) {
        return a.assignmentAverageScore - b.assignmentAverageScore;
    }
    return b.assignmentAverageScore - a.assignmentAverageScore;
};
export var getCoursesFromSearchKeyword = function (searchKeyword, courseList) {
    if (courseList === void 0) { courseList = []; }
    return courseList.filter(function (course) { return course.courseTitle.toLowerCase().includes(searchKeyword.toLowerCase()); });
};
